import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import NoDataFound from "common/component/NoDataFound";
import DeleteIcon from 'common/customIcons/delete';
import { formatTimeTo12Hour } from "utilities/common";
import { Add, Margin } from "@mui/icons-material";

const TimeSlotDayAccordion = ({
  canEdit, canCreate, canDelete,
  day = "Monday",
  slots = [],
  onEdit = () => { },
  onDelete = () => { },
}) => {

  return (
    <Box mx={2} my={1}>
      <Accordion elevation={0}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" fontWeight="bold">
            {day}
          </Typography>
          {
            slots.length !== 0 &&
            <Chip
              label={`${slots.length} ${slots.length === 1 ? "Slot" : "Slots"}`}
              size="small"
              sx={{
                ml: 2,
                backgroundColor: "#F5E8FF",
                color: "#9B39FF",
                fontWeight: 500,
                borderRadius: 2,
                height: 24,
              }}
            />
          }
          {
            slots.length === 0 ?
              <>
                {
                  canCreate &&
                  <IconButton
                    disabled={!canCreate}
                    size="small"
                    color="primary"
                    className="edit-acc-icon"
                    onClick={(e) => { e.stopPropagation(); onEdit() }}
                  >
                    <Add fontSize="small" />
                  </IconButton>
                }
              </>
              :
              <>
                {
                  canEdit &&
                  <IconButton
                    size="small"
                    color="primary"
                    className="edit-acc-icon"
                    onClick={(e) => { e.stopPropagation(); onEdit() }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                }</>


          }

        </AccordionSummary>

        <AccordionDetails sx={{ p: 0 }}>
          <TableContainer sx={{ maxHeight: 300 }}>
            <Table stickyHeader aria-label="time slots table">
              <TableHead sx={{ backgroundColor: "#f7f7fa" }}>
                <TableRow>
                  <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1 }}>
                    Time Slot
                  </TableCell>
                  <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1 }}>
                    Max Qty of Orders Per Slot
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{ color: "grey.600", fontSize: "0.75rem", py: 1 }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  slots?.length === 0 ?
                    <tr className="table-no-data-found"><td colSpan={3}><NoDataFound /></td></tr> :
                    <>
                      {slots?.map((slot, index) => (
                        <TableRow key={index} hover>
                          <TableCell>
                            <Typography variant="body2">{formatTimeTo12Hour(slot?.startTime)} - {formatTimeTo12Hour(slot?.endTime)}</Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {slot?.overallOrderLimit}
                            </Typography>
                          </TableCell>

                          <TableCell align="right">
                            <Box display="flex" alignItems="center" justifyContent="flex-end" className="m-0">
                              <IconButton
                                disabled={!canDelete}
                                size="small"
                                color="error"
                                sx={{ ml: 1 }}
                                onClick={() => onDelete(slot)}
                              >
                                <DeleteIcon width='16px' height='16px' />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                }
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default TimeSlotDayAccordion;
